import {
  Button,
  mergeClasses,
} from '@fluentui/react-components';
import { Pause20Filled, Play20Filled } from '@fluentui/react-icons';
import React, { useEffect } from 'react';
import { useStyles } from './style';
import type { PlayPauseButtonProps } from '../types';

export const PlayPauseButton = ({
  usePlayPause,
  i18n,
  activity,
  clipchampUrl,
}: PlayPauseButtonProps) => {
  const classes = useStyles();
  const { props, playing } = usePlayPause();

  useEffect(() => {
    if (activity && activity.trace && playing) {
      activity.trace(`ClipchampVideoPlayer: Playing video, Url: ${clipchampUrl}`);
    }
  }, [playing, clipchampUrl, activity]);

  return (
    <Button
      {...props}
      className={mergeClasses('play-pause-btn', classes.playPause)}
      appearance="secondary"
      icon={playing ? <Pause20Filled /> : <Play20Filled />}
      aria-label={playing ? i18n && i18n.getString(_TL_('pause')) : i18n && i18n.getString(_TL_('play'))}
    />
  );
};
